import { useMemo } from 'react'

import isInElectron from './is-in-electron'

const useIsInElectron = (): boolean => useMemo(() => isInElectron(), [])

export default useIsInElectron
